import { NgModule } from '@angular/core';

import { ImageDefaultComponent } from './image-default.component';

@NgModule({
	declarations: [ImageDefaultComponent],
	imports: [],
	exports: [ImageDefaultComponent],
})
export class ImageDefaultModule {}
